/**
 * Kısa geri bildirim sesleri (`public/` kökünden).
 *
 * Ses çalmak başarısız olursa (tarayıcı otomatik oynatmayı engellediyse, dosya
 * yoksa) sessizce yutulur — geri bildirim sesi hiçbir akışı durdurmamalı.
 *
 * <p>Test ortamı: jsdom `HTMLMediaElement.play` implementasyonu içermez. Buradaki
 * try/catch yalnız JS hatasını yakalar, jsdom'un konsola bastığı "Not implemented"
 * uyarısını engellemez; o yüzden `src/test/setup.ts` içinde `play` stub'lanır.
 */
function play(src: string): void {
  try {
    new Audio(src).play()?.catch(() => {})
  } catch {
    // no-op
  }
}

export function playClickSound(): void {
  play('/click.mp3')
}

export function playSuccessSound(): void {
  play('/success.mp3')
}
